import { Check } from "lucide-react"

import { useI18n, type MessageKey } from "@/i18n"
import { cn } from "@/lib/utils"
import type { SearchScope } from "@/types/api"

const OPTIONS: { scope: SearchScope; label: MessageKey; title: MessageKey }[] = [
  { scope: "sharepoint", label: "scope.sharepoint", title: "scope.sharepointTitle" },
  { scope: "mail", label: "scope.mail", title: "scope.mailTitle" },
  { scope: "teams", label: "scope.teams", title: "scope.teamsTitle" },
]

interface ScopePickerProps {
  scopes: SearchScope[]
  onToggle: (scope: SearchScope) => void
}

/** Classic mode: which sources a request searches. Mail and Teams use the user's own token. */
export function ScopePicker({ scopes, onToggle }: ScopePickerProps) {
  const { t } = useI18n()
  return (
    <div role="group" aria-label={t("scope.aria")} className="flex items-center gap-1">
      {OPTIONS.map(({ scope, label, title }) => {
        const checked = scopes.includes(scope)
        return (
          <button
            key={scope}
            type="button"
            role="checkbox"
            aria-checked={checked}
            title={t(title)}
            onClick={() => onToggle(scope)}
            className={cn(
              "flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs transition-colors",
              checked
                ? "border-orange/35 bg-orange-tint text-fg1"
                : "border-transparent text-fg3 hover:bg-elevated hover:text-foreground",
            )}
          >
            <Check className={cn("size-3.5 shrink-0", !checked && "opacity-0")} />
            {t(label)}
          </button>
        )
      })}
    </div>
  )
}
